import Raven from 'raven-js';
import { getApiConfigs, captureUndefinedPortalError, apiClientWithMiddleware } from './utils';
import { debug } from '../utils/DebugUtil';
export const PERSISTENT_API = '/persistent-notifications/v1';
export const getBannerNotifications = () => {
  const {
    queryConfig,
    clientConfig
  } = getApiConfigs();
  if (!queryConfig.query.portalId) {
    captureUndefinedPortalError();
    return Promise.resolve(null);
  }
  const url = `${PERSISTENT_API}/notifications`;
  return apiClientWithMiddleware(clientConfig).getWithResponse(url, queryConfig).then(response => {
    if (response && response.data) {
      return response.data;
    }
    return null;
  }).catch(error => {
    if (error.status !== 0) {
      debug(`Error while retrieving banner notifications: ${error}`, error);
      throw error;
    }
    return null;
  });
};
export const markAs = ({
  id,
  deliveryMethod,
  action
}) => {
  const {
    queryConfig,
    clientConfig
  } = getApiConfigs();
  if (!queryConfig.query.portalId) {
    captureUndefinedPortalError();
    return Promise.resolve(null);
  }
  return apiClientWithMiddleware(clientConfig).put(`${PERSISTENT_API}/notifications/notification/${id}/deliveryMethod/${deliveryMethod}/action/${action}`, queryConfig).catch(error => {
    if (error.status !== 0) {
      console.debug('Error while marking notification as %s (id: %d, deliveryMethod: %s)', action, id, deliveryMethod, error);
      Raven.captureException(error);
      throw error;
    }
  });
};